<template>
  <div class="collection-slider-images">
    <ClientOnly>
      <template #fallback>
        <CollectionPlaceholder/>
      </template>
      <template v-if="$viewport.isGreaterOrEquals('lg')">
        <div
          ref="paginationContainer"
          class="collection-slider-images__pagination collection-slider-images__pagination_with-arrow"
        >
          <swiper
            :modules="[Thumbs, Navigation]"
            :free-mode="true"
            :slides-per-view="dynamicSlidesPerView"
            :slides-per-group="dynamicSlidesPerGroup"
            :space-between="dynamicSpaceBetween"
            :direction="'vertical'"
            class="swiper swiper-initialized swiper-horizontal swiper-vertical"
            @swiper="setThumbsSwiper"
          >
            <template
              v-for="(imageId) in initContent"
              :key="`product-image-${product.id}-${imageId.url}`"
            >
              <swiper-slide>
                <nuxt-img
                  v-if="imageId.type==='img'"
                  :src="String(imageId.url)"
                  width="116"
                  fit="default"
                  border="default"
                  loading="lazy"
                  placeholder
                  decoding="auto"
                  :alt="`product-image-${product.id}-${imageId.url}`"
                />
                <div
                  v-if="imageId.type === 'video'"
                  class="video-preview"
                  :class="{'video-preview_none': !getLinkForPreview(imageId.source!).length}"
                >
                  <img
                    v-if="getLinkForPreview(imageId.source!) && !imageId.preview"
                    class="preview"
                    :src="getLinkForPreview(imageId.source!)"
                    alt="img"
                  >
                  <nuxt-img
                    v-if="!getLinkForPreview(imageId.source!) && imageId.preview"
                    class="preview"
                    :src="String(imageId.preview)"
                    alt="preview-image"
                  />
                  <img
                    class="play-icon"
                    alt="play"
                    src="~/assets/img/svg/gallery/play.svg"
                  >
                </div>

                <template v-if="imageId.hint">
                  <div
                    v-html="imageId.hint"
                    class="collection-slider-images__pagination-slide-hint"
                  />
                </template>
              </swiper-slide>
            </template>
          </swiper>

          <div
            v-if="shouldShowScrollArrowUp"
            class="collection-slider-images__pagination-arrow-area collection-slider-images__pagination-arrow-area_top"
            @click="scrollThumbsUp"
          >
            <div class="collection-slider-images__pagination-arrow">
              <img
                src="~/assets/img/svg/common/arrow-down.svg"
                loading="lazy"
                decoding="async"
                class="collection-slider-images__pagination-arrow-up"
                alt=""
              />
            </div>
          </div>

          <div
            v-if="shouldShowScrollArrow"
            class="collection-slider-images__pagination-arrow-area"
            @click="scrollThumbsDown"
          >
            <div class="collection-slider-images__pagination-arrow">
              <img
                src="~/assets/img/svg/common/arrow-down.svg"
                loading="lazy"
                decoding="async"
                alt=""
              />
            </div>
          </div>

          <div
            v-if="shouldShowScrollToUserPhoto"
            class="collection-slider-images__pagination-users-photo-button"
            @click="scrollThumbsToUserPhoto"
          >
            <nuxt-img
              v-if="indexFirstPhotoFromUsers"
              :src="initContent?.[indexFirstPhotoFromUsers]?.url"
              width="116"
              fit="default"
              border="default"
              loading="lazy"
              placeholder
              decoding="auto"
            />
            <div class="collection-slider-images__pagination-slide-hint">Фото от клиентов</div>
          </div>
        </div>
      </template>
      <div
        class="collection-slider-images__images slider-images-navigation-button"
        :class="{'--disabled-from-zoom': isMediaDisabledAction}"
      >
        <swiper
          :loop="Boolean(initContent.length > 1)"
          :modules="[Navigation, Thumbs, Pagination, Virtual]"
          :navigation="true"
          :virtual="Boolean(initContent.length > 4)"
          :thumbs="$viewport.isGreaterOrEquals('lg') ? { swiper: controlledThumbs } : undefined"
          :space-between="20"
          :pagination="{type: 'bullets'}"
          :breakpoints="{
            1024: {
              zoom: false,
              pagination: { enabled:false },
            }
          }"
          @click="openGallery"
          @slideChange="changeActiveSlide"
          @swiper="initMainSwiper"
          @zoomChange="onZoomSlideChange"
        >
          <swiper-slide
            v-for="(imageId, index) in initContent"
            :key="`product-image-${product.id}-${imageId.url}`"
          >
            <div class="preload-plug"/>
            <template v-if="imageId.type==='img'">
              <nuxt-img
                :src="String(imageId.url)"
                width="1094px"
                height="768px"
                :fit="imageId?.fit || 'default'"
                :modifiers="{'border': 'default'}"
                :loading="Boolean(index > 0) ? 'lazy' : 'eager'"
                decoding="auto"
                :alt="`product-image-${product.id}-${imageId.url}`"
                :class="{
                    '--contain': Boolean(imageId?.fit === 'contain')
                  }"
              />
              <nuxt-img
                :src="String(imageId.url)"
                width="1094px"
                height="768px"
                :fit="imageId?.fit || 'default'"
                :modifiers="{'border': 'default'}"
                :loading="Boolean(index > 0) ? 'lazy' : 'eager'"
                decoding="auto"
                class="--mobile-top"
                :alt="`product-image-${product.id}-${imageId.url}`"
              />
            </template>
            <iframe
              v-if="imageId.type === 'video' && activeSlide === (index + 1)"
              :src="imageId.url"
              allowfullscreen
              frameborder="0"
              width="100%"
              height="100%"
              allow="autoplay"
              encrypted-media
              picture-in-picture
            />
          </swiper-slide>
        </swiper>
        <template v-if="$viewport.isGreaterOrEquals('lg')">
          <template v-if="false && isVisibleButtonBuySet && isShowDots">
            <div
              class="collection-slider-images__button-full-buy"
              :class="{
                '--loading': isLoadBuySet,
              }"
              @click="buySet"
            >
              {{ isLoadBuySet ? 'Идет загрузка...' : 'Купить комплект как на фото' }}
            </div>
          </template>
          <template v-if="activeSlideHint">
            <div class="collection-slider-images__slide-hint">
              {{ activeSlideHint }}
            </div>
          </template>
          <client-only>
            <div class="collection-slider-images__count-navigation count-info-sliders">
              {{ activeSlide }}/{{ initContent.length }}
            </div>
          </client-only>
          <template v-if="isShowDots">
            <ProductDot
              v-for="(item) in productsDots"
              :key="`ProductDot-${item.id}`"
              :info="item"
            />
          </template>
        </template>
      </div>
    </ClientOnly>

    <div
      v-if="false && $viewport.isGreaterOrEquals('lg')"
      class="collection-slider-images__wish"
      :class="{'--wish': isWish}"
    >
      <div @click="changeWish"/>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Thumbs, Pagination, Virtual } from 'swiper/modules';
import { computed, type ComputedRef, ref, onBeforeUnmount, onMounted, watch, nextTick } from 'vue';
import type { Swiper as SwiperClass } from 'swiper/types';
import { safeDestroySwiper } from '~/utils/swiper/safeDestroySwiper';
import { concatMediaContent } from '~/utils/product/concatMediaContent';
import type { IProduct } from '#sitis/internal/controllers/products/models/Product';
import useSitisWish from '#sitis/composables/useSitisWish';
import { useRouter } from '#app'

const router = useRouter()

const props = defineProps<{
  product: IProduct,
  products: IProduct[],

  isLoadBuySet: boolean
}>();

const emits = defineEmits<{
  buySet: [any];
  openGallery: [number, number[], IProduct];
}>();

const ProductDot = defineAsyncComponent(() => import('~/components/collection/ProductDot.vue'));
const {
  concatArrays,
  initMediaArrays,
  getLinkForPreview
} = concatMediaContent();
const {
  $viewport,
  ssrContext
} = useNuxtApp();

const paginationContainer = ref<HTMLElement | null>(null);
const resizeObserver = ref<ResizeObserver | null>(null);

// Логика работы для вычесление кол-во пагинации
const dynamicSlidesPerView = ref<number>(4);
const dynamicSlidesPerGroup = ref<number>(4);
const dynamicSpaceBetween = ref<number>(10);

const calculateSlidesPerView = () => {
  if (!paginationContainer.value || !process.client) return;

  const container = paginationContainer.value;
  const height = container.clientHeight;

  if (height === 0) return;

  // Получаем spaceBetween в зависимости от ширины экрана
  let spaceBetween = 10;
  if (window.innerWidth >= 1199) {
    spaceBetween = 16;
  }

  // Пытаемся измерить реальную высоту слайда из DOM
  const swiperElement = container.querySelector('.swiper') as HTMLElement;
  const firstSlide = swiperElement?.querySelector('.swiper-slide') as HTMLElement;

  let slideHeight = 0;
  if (firstSlide) {
    // Измеряем реальную высоту слайда включая padding
    const slideRect = firstSlide.getBoundingClientRect();
    slideHeight = slideRect.height;
  }

  // Если не удалось измерить, используем теоретическое значение
  if (slideHeight === 0) {
    const slideWidth = 116;
    const aspectRatio = 768 / 1094;
    slideHeight = slideWidth * aspectRatio;
  }

  // Вычисляем количество слайдов, которые помещаются в контейнер
  // Формула: (высота контейнера + spaceBetween) / (высота слайда + spaceBetween)
  const availableHeight = height;
  const slidesCount = Math.floor((availableHeight + spaceBetween) / (slideHeight + spaceBetween));

  // Ограничиваем минимальное и максимальное количество слайдов
  const minSlides = 3;
  const maxSlides = 8;
  const finalSlidesCount = Math.max(minSlides, Math.min(maxSlides, slidesCount));

  dynamicSlidesPerView.value = finalSlidesCount;
  dynamicSlidesPerGroup.value = finalSlidesCount;
  dynamicSpaceBetween.value = spaceBetween;

  // Обновляем swiper если он уже инициализирован
  nextTick(() => {
    if (thumbsSwiper.value && !thumbsSwiper.value.destroyed) {
      thumbsSwiper.value.params.slidesPerView = finalSlidesCount;
      thumbsSwiper.value.params.slidesPerGroup = finalSlidesCount;
      thumbsSwiper.value.params.spaceBetween = spaceBetween;
      thumbsSwiper.value.update();
    }
  });
};

onMounted(() => {
  if (!process.client) return;

  // Вычисляем начальное значение
  nextTick(() => {
    calculateSlidesPerView();

    resizeObserver.value = new ResizeObserver(() => {
      requestAnimationFrame(() => calculateSlidesPerView());
    });

    if (paginationContainer.value) {
      resizeObserver.value.observe(paginationContainer.value);
      // Добавляем обработчик прокрутки колесиком мыши
      paginationContainer.value.addEventListener('wheel', handleWheel, { passive: false });
    }

    // Также отслеживаем изменения размера окна для обновления spaceBetween
    window.addEventListener('resize', calculateSlidesPerView);
  });
});

const thumbsSwiper = ref<SwiperClass | null>(null);
const thumbsSwiperState = ref<number>(0);

const setThumbsSwiper = (value: SwiperClass) => {
  thumbsSwiper.value = value;
  // Пересчитываем после инициализации swiper
  nextTick(() => {
    calculateSlidesPerView();
  });

  // Отслеживаем изменения состояния swiper для обновления видимости кнопок
  if (value) {
    value.on('slideChange', () => {
      // Обновляем реактивную переменную для пересчета computed свойств
      thumbsSwiperState.value = Date.now();
    });
  }
};

// Безопасная ссылка на thumbs, которая становится null после destroy
const controlledThumbs = computed(() => {
  const instance: any = thumbsSwiper.value as any;
  return instance && !instance.destroyed ? instance : null;
});

const scrollThumbsDown = () => {
  if (controlledThumbs.value) {
    controlledThumbs.value.slideNext();
  }
};

const scrollThumbsUp = () => {
  if (controlledThumbs.value) {
    controlledThumbs.value.slidePrev();
  }
};

// Обработчик прокрутки колесиком мыши
const handleWheel = (event: WheelEvent) => {
  if (!controlledThumbs.value || !paginationContainer.value) return;

  // Проверяем, что курсор находится над контейнером пагинации
  const rect = paginationContainer.value.getBoundingClientRect();
  const isOverPagination = (
    event.clientX >= rect.left &&
    event.clientX <= rect.right &&
    event.clientY >= rect.top &&
    event.clientY <= rect.bottom
  );

  if (!isOverPagination) return;

  // Предотвращаем стандартную прокрутку страницы
  event.preventDefault();

  // Определяем направление прокрутки
  const deltaY = event.deltaY;

  if (deltaY > 0) {
    // Прокрутка вниз - переходим к следующему слайду
    if (!controlledThumbs.value.isEnd) {
      controlledThumbs.value.slideNext();
    }
  } else if (deltaY < 0) {
    // Прокрутка вверх - переходим к предыдущему слайду
    if (!controlledThumbs.value.isBeginning) {
      controlledThumbs.value.slidePrev();
    }
  }
};

const shouldShowScrollArrow = computed(() => {
  // Используем thumbsSwiperState для реактивности
  const _ = thumbsSwiperState.value;

  if (!controlledThumbs.value || !initContent.value.length) return false;

  const totalSlides = initContent.value.length;
  const visibleSlides = controlledThumbs.value.slidesPerViewDynamic();

  return totalSlides > visibleSlides && !controlledThumbs.value.isEnd;
});

const shouldShowScrollArrowUp = computed(() => {
  // Используем thumbsSwiperState для реактивности
  const _ = thumbsSwiperState.value;

  if (!controlledThumbs.value || !initContent.value.length) return false;

  const totalSlides = initContent.value.length;
  const visibleSlides = controlledThumbs.value.slidesPerViewDynamic();

  return totalSlides > visibleSlides && !controlledThumbs.value.isBeginning;
});

const activeSlide = ref(1);

// Индекс первого фото от пользователей
const indexFirstPhotoFromUsers = computed(() => {
  return initContent.value.findIndex((item) => item.hint)
})
// Условие показа кнопки прокрутки к фото от пользователей
const shouldShowScrollToUserPhoto = computed(() => {
  if(!thumbsSwiper.value || !initContent.value.length) return false;
  const visibleSlides = thumbsSwiper.value.slidesPerViewDynamic();

  return indexFirstPhotoFromUsers.value > visibleSlides && (indexFirstPhotoFromUsers.value - visibleSlides) >= thumbsSwiper.value.activeIndex
})
// Функция для прокрутки маленького к фото от пользователей
const scrollThumbsToUserPhoto = () => {
  if (controlledThumbs.value && mainSlider.value) {
    controlledThumbs.value.slideTo(indexFirstPhotoFromUsers.value)
    mainSlider.value.slideTo(indexFirstPhotoFromUsers.value + 1 )
    controlledThumbs.value.update()
  }
}

const changeActiveSlide = (event: SwiperClass) => {
  activeSlide.value = (event?.realIndex || 0) + 1;
};

const productsDots = computed(() => {
  return (props.product?.productSetImageDots || [])
    .filter((productDot: any) => props.products.find((t: IProduct) => String(t.id) === String(productDot.id || productDot.product_id)));
});
const isShowDots = computed(() => Boolean(mainSlider.value && activeSlide.value === 1 && (props.product.productSetImageDots || []).length > 0));

const isVisibleButtonBuySet = computed(() => {
  const products = props.products || [];
  let countAvailableProducts = 0;
  productsDots.value.forEach((productDot: any) => {
    const product = products.find((t) => t.id === productDot.id);
    if (!product?.hasOptions) {
      countAvailableProducts = countAvailableProducts + 1;
    } else if (product?.hasOptions && !productDot?.option) {
    } else {
      const productOptions = product?.options || [];

      let countAvailableOption = 0;
      Object.keys(productDot?.option || {})
        .forEach((optionKey: string) => {
          const optionValue: any = productDot?.option[optionKey];
          const isAvailableValue = Boolean((productOptions.find((t: any) => String(t.id) === String(optionKey))?.variants || []).find((t: any) => String(t.id) === String(optionValue)));
          if (isAvailableValue) {
            countAvailableOption = countAvailableOption + 1;
          }
        });

      if (countAvailableOption === Object.keys(productDot?.option || {}).length) {
        countAvailableProducts = countAvailableProducts + 1;
      }
    }
  });

  if (countAvailableProducts === 0) {
    return false;
  }
  return countAvailableProducts === (productsDots.value || []).length;
});
const buySet = () => {
  if (props.isLoadBuySet) {
    return;
  }
  const products = (productsDots.value || []);
  emits('buySet', products);
};

const mainSlider: any = ref<SwiperClass | null>(null);
const initMainSwiper = (value: SwiperClass) => {
  mainSlider.value = value;
};

const initContent = computed(() => {
  const {
    contentVideo,
    contentImg
  } = initMediaArrays({
    videos: props.product.videos,
    imagesIds: props.product.imageIds
  });

  let _items = concatArrays(contentImg, contentVideo);
  if ([...(props?.product?.dynamicFields?.user_images_ids || [])].length > 0) {
    [...(props?.product?.dynamicFields?.user_images_ids || [])].map((imageId: number) => {
      _items.push({
        type: 'img',
        fit: 'contain',
        url: String(imageId),
        hint: 'Фото от клиентов'
      });
    });
  }

  return _items;
});

watch(() => initContent.value.length, () => {
  nextTick(() => {
    calculateSlidesPerView();
  });
});

const openGallery = () => {
  if (isMediaDisabledAction.value) {
    return;
  }
  emits('openGallery', mainSlider.value!.realIndex, [1], props.product);
};

const isMediaDisabledAction: Ref<boolean> = ref(false);
const onZoomSlideChange = (swiper: any, scale: any, imageEl: any, slideEl: any) => {
  if (scale > 1.1) {
    mainSlider.value.allowTouchMove = false;
    isMediaDisabledAction.value = true;
  } else {
    mainSlider.value.allowTouchMove = true;
    isMediaDisabledAction.value = false;
  }
  ;
};

const wishList = useSitisWish();
const isWish = computed(() => {
  return wishList.isInWish(Number.parseFloat(String(props.product.id)));
});
const changeWish = async () => {
  if (isWish.value) {
    await wishList.removeItemFromWishList(Number.parseFloat(String(props.product.id)));
  } else {
    await wishList.addToWishList({ id: Number.parseFloat(String(props.product.id)) });
  }
};

const activeSlideHint: ComputedRef<string> = computed(() => {
  return initContent.value?.[activeSlide.value - 1]?.hint || '';
});

const handleDestroySwipers = () => {
  safeDestroySwiper(mainSlider.value);
  safeDestroySwiper(thumbsSwiper.value);
  mainSlider.value = null;
  thumbsSwiper.value = null;
};

// уничтожаем вручную свайперы
onBeforeUnmount(() => {
  if (resizeObserver.value && paginationContainer.value) {
    resizeObserver.value.unobserve(paginationContainer.value);
    resizeObserver.value.disconnect();
  }
  if (paginationContainer.value && process.client) {
    paginationContainer.value.removeEventListener('wheel', handleWheel);
  }
  if (process.client) {
    window.removeEventListener('resize', calculateSlidesPerView);
  }
  handleDestroySwipers();
});

// Перехватываем навигацию назад
// router.beforeEach((to, from, next) => {
//   // Если уходим со страницы
//   if (from.path.includes('/collection')) {
//     handleDestroySwipers()
//
//     setTimeout(() => {
//       next()
//     }, 50)
//   } else {
//     next()
//   }
// })
</script>

<style scoped lang="scss">
.collection-slider-images__pagination {
  .swiper-slide {
    height: auto!important;
    &::after {
      padding-top: calc( 768 / 1094 * 100%)!important;
    }
  }
  &.collection-slider-images__pagination_with-arrow {
    position: relative;
    overflow: visible;
  }
}

.collection-slider-images__pagination-arrow-area {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 20px;
  border-radius: 0 0 8px 8px;
  cursor: pointer;
  z-index: 1;
  &:after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: white;
    z-index: 0;
  }
  &:hover {
    &:before {
      content: '';
      display: block;
      position: relative;
      width: 100%;
      height: 100%;
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.37) -34.88%, rgba(0, 0, 0, 0) 99.93%);
      z-index: 1;
      border-radius: 0 0 8px 8px;
    }
  }
  &.collection-slider-images__pagination-arrow-area_top {
    top: 0;
    bottom: auto;
    border-radius: 8px 8px 0 0;
    &:hover {
      &:before {
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.37) -34.88%, rgba(0, 0, 0, 0) 99.93%);
        border-radius: 8px 8px 0 0;
      }
    }
  }
}

.collection-slider-images__pagination-arrow {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  .collection-slider-images__pagination-arrow-area_top & {
    top: 0;
    bottom: auto;
  }
  .collection-slider-images__pagination-arrow-up {
    transform: rotate(180deg);
  }
}
.collection-slider-images__pagination-users-photo-button {
  position: absolute;
  bottom: 20px;
  width: 100%;
  height: auto;
  border-radius: 8px;
  cursor: pointer;
  z-index: 1;
  padding-top: calc(806 / 1148 * 100%) !important;
  overflow: hidden;
  & > img {
    //height: auto;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  &:after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.5);
    z-index: 0;
  }
  &:hover {
    &:after {
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.37) -34.88%, rgba(0, 0, 0, 0) 99.93%);
    }
  }
  .collection-slider-images__pagination-slide-hint {
    z-index:1;
  }
}
</style>
